/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';
export const OutlinedCircleIconConfig = {
  name: 'OutlinedCircleIcon',
  height: 512,
  width: 512,
  svgPath: 'M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200z',
  yOffset: '',
  xOffset: '',
  transform: ''
};
export default createIcon(OutlinedCircleIconConfig);
//# sourceMappingURL=outlined-circle-icon.js.map